module.exports = __webpack_public_path__ + "static/media/5DPO14.5631a601.jpg";